(function () {
  'use strict';

  // News grid filters (using https://isotope.metafizzy.co)
  // ----------------------------------------
  var $grid = $( '.news-grid' ).isotope( {
    itemSelector: '.news-grid-item',
    layoutMode: 'fitRows',
    fitRows: {
      equalheight: true
    },
    filter: ':nth-child(-n+9)',
  });

  $( '.news-grid-filter' ).on( 'click', 'button', function() {
    var filterValue = $(this).attr( 'data-filter' );

    $( '.news-grid-filter button' ).removeClass( 'active' );
    $(this).addClass( 'active' );

    $grid.isotope( {
      filter: filterValue,
    });
  }) ;
})();